export default __webpack_public_path__ + "static/media/lk.d8d3e19a.svg";